import { SET_CUSTOM_CONTENT_TEXT_VALUE_IN_CONFIG } from '../../constants/ActionTypes';

const onConfigCustomContentChange = (dispatch, prefix) => (path, callback) => value => {
    // Extract language code from the path (e.g., "en.head" or "en.bottom.products")
    const pathParts = path.split('.');
    const languageCode = pathParts[0];
    const remainingPath = pathParts.slice(1).join('.');
    
    // If the path has multiple parts like "bottom.products"
    if (remainingPath.includes('.')) {
        const [side, code] = remainingPath.split('.');
        dispatch({
            type: SET_CUSTOM_CONTENT_TEXT_VALUE_IN_CONFIG,
            parent: prefix,
            languageCode: languageCode,
            side: side,
            code: code,
            value: value
        });
    } else {
        // For simple paths like "head"
        dispatch({
            type: SET_CUSTOM_CONTENT_TEXT_VALUE_IN_CONFIG,
            parent: prefix,
            languageCode: languageCode,
            code: remainingPath,
            value: value
        });
    }
    
    callback && typeof callback === 'function' && callback(dispatch);
};

export { onConfigCustomContentChange };


// WEBPACK FOOTER //
// ./src/components/helpers/ConfigStoreHelpers.js